import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../shared/authentication/auth.service';

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss'],
  standalone: false
})
export class UserLoginComponent implements OnInit {

  constructor(private authService: AuthService) { }

  ngOnInit() {
  this.authService.startAuthentication();
  }

}
